export const DIARY_FIELD_KEYS = ['feed', 'water', 'training', 'notes'];

export const DIARY_FIELD_LIMITS = {
  feed: 2000,
  water: 2000,
  training: 2000,
  notes: 5000
};

const cleanDiaryValue = (key, value) => {
  const text = typeof value === 'string' ? value.trim() : '';
  return text.slice(0, DIARY_FIELD_LIMITS[key]);
};

export const normalizeDiaryPatch = (entry = {}) => {
  const normalized = { entry_date: String(entry.entry_date || '') };
  for (const key of DIARY_FIELD_KEYS) {
    if (Object.prototype.hasOwnProperty.call(entry, key)) {
      normalized[key] = cleanDiaryValue(key, entry[key]);
    }
  }
  return normalized;
};

export const normalizeDiaryEntry = (entry = {}) => {
  const normalized = { entry_date: String(entry.entry_date || '') };
  for (const key of DIARY_FIELD_KEYS) normalized[key] = cleanDiaryValue(key, entry[key]);
  return normalized;
};

export const isDiaryEntryEmpty = (entry) =>
  DIARY_FIELD_KEYS.every((key) => !String(entry?.[key] || '').trim());
